module.exports = __webpack_public_path__ + "static/media/knk.5a90b44e.png";